import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayType), {
    message: _ctx.message,
    requiredInputs: _ctx.requiredInputsData,
    isLastMessage: _ctx.isLastMessage,
    isShowMessageTail: _ctx.isShowMessageTail,
    avatar: _ctx.avatar,
    respondentId: _ctx.respondentId,
    buttons: _ctx.separationButtons,
    disableButton: !_ctx.isValidRequiredInputs,
    showInvalidRequiredInputs: _ctx.showInvalidRequiredInputs,
    onClickButton: _ctx.clickOnButton,
    onChangeControl: _ctx.changeControl,
    class: "slow-showing-animation"
  }, null, 40, ["message", "requiredInputs", "isLastMessage", "isShowMessageTail", "avatar", "respondentId", "buttons", "disableButton", "showInvalidRequiredInputs", "onClickButton", "onChangeControl"]))
}